import { Modal, ModalSizeEnum, PrimaryButton } from '@systemeio/ui'
import RuleSave from 'modules/automation-rules/components/rule-save'
import { useRuleState } from 'modules/automation-rules/hooks/use-rule-state'
import { SpecificTriggerRulesProps } from 'modules/automation-rules/specific-trigger-rules'
import React, { useRef, useState } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { SpecificTriggerRule } from './specific-trigger-rule'

export interface SpecificTriggerRuleCreateProps extends SpecificTriggerRulesProps {}

const SpecificTriggerRuleCreate = ({
  availableTriggersData,
  getRelatedAndUnrelatedTriggersData,
  specificTriggerRulesData,
  customAddTriggerHandler,
  noRelatedMessage,
}: SpecificTriggerRuleCreateProps) => {
  const { t } = useLocoTranslation()
  const [opened, setOpened] = useState(false)

  const { tempState, setTempState, errors, setErrors, clearState } = useRuleState()

  const maxTriggerId = useRef(0)
  const maxActionId = useRef(0)

  const [isFetching, setIsFetching] = useState(false)

  const afterSave = async () => {
    await specificTriggerRulesData.mutate()
    await availableTriggersData.mutate()
    setOpened(false)
  }

  return (
    <div className={'flex justify-center px-6 py-4 lg:px-8'}>
      <PrimaryButton
        onClick={() => setOpened(true)}
        disabled={!availableTriggersData.data || availableTriggersData.data.length === 0}
      >
        {t('dashboard.funnel.automation_rules.add_rule')}
      </PrimaryButton>
      <Modal
        afterLeave={clearState}
        size={ModalSizeEnum.big}
        isFetching={isFetching}
        title={t('dashboard.automation_rule.edit.create_title')}
        opened={opened}
        onClose={() => setOpened(false)}
      >
        <SpecificTriggerRule
          noRelatedMessage={noRelatedMessage}
          isFetching={isFetching}
          tempState={tempState}
          setTempState={setTempState}
          errors={errors}
          maxActionId={maxActionId}
          maxTriggerId={maxTriggerId}
          availableTriggers={availableTriggersData.data}
          getRelatedAndUnrelatedTriggersData={getRelatedAndUnrelatedTriggersData}
          customAddTriggerHandler={customAddTriggerHandler}
        />
        <div className={'mt-5 flex justify-center'}>
          <RuleSave
            setErrors={setErrors}
            afterSave={afterSave}
            isFetching={isFetching}
            setIsFetching={setIsFetching}
            rule={tempState}
          />
        </div>
      </Modal>
    </div>
  )
}

export default SpecificTriggerRuleCreate
